import { render, staticRenderFns } from "./PreviousOwnershipsViewer.vue?vue&type=template&id=24448269&scoped=true&lang=pug"
import script from "./PreviousOwnershipsViewer.vue?vue&type=script&lang=js"
export * from "./PreviousOwnershipsViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24448269",
  null
  
)

export default component.exports